export default __webpack_public_path__ + "static/media/deploy.edc8741c.svg";